import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	accountSettings: {
		defaultMessage: 'Atlassian account settings',
		id: 'atlassian-navigation.settings.menu.personal.account-settings',
		description: 'Account settings message',
	},
	accountSettingsDescription: {
		defaultMessage: 'Manage your language, time zone, and other profile information.',
		id: 'atlassian-navigation.settings.menu.personal.account-settings-description',
		description: 'Atlassian account settings descriptions',
	},
	personalJiraSettings: {
		defaultMessage: 'Personal Jira settings',
		id: 'atlassian-navigation.settings.menu.personal.personal-jira-settings',
		description: 'Personal Jira settings',
	},
	personalJiraSettingsDescription: {
		defaultMessage: 'Manage your email notifications and other Jira settings.',
		id: 'atlassian-navigation.settings.menu.personal.personal-jira-settings-description',
		description: 'Personal Jira settings descriptions',
	},
	// Nav4 Messages
	generalSettingsLabelNonFinal: {
		defaultMessage: 'General settings',
		id: 'atlassian-navigation.settings.menu.personal.general-settings-label-non-final',
		description: 'Label for general settings dropdown item',
	},
	generalSettingsDescriptionNonFinal: {
		defaultMessage: 'Manage language, time zone, and other personal preferences',
		id: 'atlassian-navigation.settings.menu.personal.general-settings-description-non-final',
		description: 'Description for general settings dropdown item',
	},
	notificationSettingsLabelNonFinal: {
		defaultMessage: 'Notification settings',
		id: 'atlassian-navigation.settings.menu.personal.notification-settings-label-non-final',
		description: 'Label for notification settings dropdown item',
	},
	notificationSettingsDescriptionNonFinal: {
		defaultMessage: 'Manage email and in-product notifications from Jira',
		id: 'atlassian-navigation.settings.menu.personal.notification-settings-description-non-final',
		description: 'Description for notification settings dropdown item',
	},
});
